import { render, staticRenderFns } from "./Kia.vue?vue&type=template&id=36c7f4fe&"
import script from "./Kia.vue?vue&type=script&lang=js&"
export * from "./Kia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports